module.exports = __webpack_public_path__ + "static/media/partner-site-a-5.3a3a4864.png";